module.exports = __webpack_public_path__ + "static/media/404.6b588cc1.png";